import { ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { IBookingV4ServiceItem } from '../types';
import { getCurrentDuration, getServiceRangeLabel } from './helpers';
import { IconButton, ServiceRowBox } from './styles';

type Props = {
  service: IBookingV4ServiceItem;
  onRemove: () => void;
  onEditTime: () => void;
};

const ServiceRow = ({ service, onRemove, onEditTime }: Props) => {
  return (
    <ServiceRowBox>
      <div className="info">
        <span className="service-name">{service.serviceName}</span>
        <div className="time" onClick={onEditTime}>
          <ClockCircleOutlined />
          <span>{getServiceRangeLabel(service) || 'Set start time'}</span>
        </div>
      </div>
      <span className="duration">{getCurrentDuration(service)}m</span>
      <IconButton type="button" className="small delete" onClick={onRemove}>
        <CloseOutlined />
      </IconButton>
    </ServiceRowBox>
  );
};

export default ServiceRow;
